import { setIntlShape } from "./intl-context";
import { FC, useContext } from "react";
import { IntlContext, IntlShape } from "react-intl";

export const HoistIntlContextComponent: FC = () => {
  const intlContext: IntlShape = useContext(IntlContext as any);
  setIntlShape(intlContext);
  return null;
};
